import { useDetectDevice } from '@/composables/device'
import { downloadBlobUrl } from '@/lib/utils'

export const useShare = () => {
  const { isMobile } = useDetectDevice()

  const shareLinkAsync = async(url, title, onShareUnavailable = null) => {
    if (isMobile.value && navigator?.share) {
      try {
        await navigator.share({ title: title, url: url })
      } catch (error) {
        console.error('Error sharing', error)
      }
    } else {
      if (onShareUnavailable) {
        if (navigator?.clipboard) {
          await navigator.clipboard.writeText(url)
        }
        onShareUnavailable(url, title, navigator?.clipboard)
      } else {
        console.warn('Web Share API not available')
      }
    }
  }

  const shareFileAsync = async(blobUrl, fileName, title) => {
    const files = isMobile.value && navigator?.canShare
      ? [new File([await (await fetch(blobUrl)).blob()], fileName, { type: 'application/pdf' })]
      : null
    if (!files || !navigator.canShare({ files })) {
      downloadBlobUrl(blobUrl, fileName)
      return true
    }
    try {
      await navigator.share({ files, title })
      return true
    } catch (err) {
      if (err.name === 'AbortError') return false
      throw err
    }
  }

  return {
    shareLinkAsync,
    shareFileAsync,
  }
}
